import { FC } from 'react';

import { EvSelectNew } from '@evinced-private/ui-common';

import { LABELS_SELECT_LABELS } from './LabelsSelect.labels';
import { ILabelsSelect } from './LabelsSelect.types';

import './LabelsSelect.scss';

export const LabelsSelect: FC<ILabelsSelect> = ({
	labelKey,
	options,
	value,
	onChange,
	isMulti = false,
	placeholder = LABELS_SELECT_LABELS.DEFAULT_PLACEHOLDER,
	ariaLabel = LABELS_SELECT_LABELS.DEFAULT_ARIA_LABEL,
	description = null
}) => {
	return (
		<EvSelectNew
			id={labelKey}
			label={ariaLabel}
			options={options}
			selectedValue={value}
			onSelectChange={onChange}
			isMultiple={isMulti}
			tooltipContent={description}
			placeholder={placeholder}
			ariaLabel={ariaLabel}
			listboxWidth="100%"
			someItemsSelectedText={(numberOfItems: number) =>
				LABELS_SELECT_LABELS.getSomeItemsSelectedText(ariaLabel, numberOfItems)
			}
			allSelectedPlaceholder={LABELS_SELECT_LABELS.getAllSelectedPlaceholder(
				ariaLabel,
				options.length
			)}
		/>
	);
};
